import './index.scss';
import makeLoadingSkeleton from './skeleton';
import { getFromLocalStorage, putInLocalStorage } from '../utils/data/local_storage';
import { getActiveHotelUuid, getCookie } from '../utils';

const templateOptions = {
    booking: {
        showMinimizeButton: true,
        showPopButton: true,
    },
    payment: {
        showMinimizeButton: false,
        showPopButton: false,
    }
}

$(() => {
    const holder = $("#bookingBar");
    const bookingPreviewModal = $('#bookingPreviewModal');
    const bookingPreviewIframe = bookingPreviewModal.find('#bookingPreviewIframe');
    const popModalButton = bookingPreviewModal.find("#popModal");
    const closeModalButton = bookingPreviewModal.find("#closeModal");
    const minimizeModalButton = bookingPreviewModal.find("#minimizeModal");
    const loadingWrapper = bookingPreviewModal.find("#loadingWrapper");
    let pathTaken = [];
    let openBookingUuid = "";
    let openPageUrl = "";
    let shouldUpdateCalendar = false;

    const getBookingNumber = (text) => {
        const number = text.match('#[0-9]{5}-[0-9]{3}\.[0-9]{3}')
        if (number && number[0]) return number;
    }

    window.getBookingNumber = getBookingNumber;

    const getBookingUuuid = (text) =>
        text.match('[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}')[0];

    window.getBookingUuuid = getBookingUuuid;

    const getBookingList = () => {
        const data = getFromLocalStorage('hflw_taskbar_booking_list');
        return data ? JSON.parse(data) : {};
    }

    window.getBookingList = getBookingList;

    const bookingListAdd = (bookingUuid, bookingNumber, url) => {
        let bookingList = getBookingList();
        const hotelUuid = getActiveHotelUuid();
        if (!bookingList[hotelUuid]) bookingList[hotelUuid] = {};
        bookingList[hotelUuid][bookingUuid] = { url, bookingNumber };
        putInLocalStorage('hflw_taskbar_booking_list')(true)(bookingList);
        sessionStorage.setItem('hflw_taskbar_booking_list', JSON.stringify(bookingList))
        updateBookingListTabs(bookingList[hotelUuid]);
    }

    window.bookingListAdd = bookingListAdd;

    const bookingListRemove = (bookingUuid) => {
        let bookingList = getBookingList();
        const hotelUuid = getActiveHotelUuid();
        if (bookingList[hotelUuid] && bookingList[hotelUuid][bookingUuid]) {
            delete bookingList[hotelUuid][bookingUuid];
            putInLocalStorage('hflw_taskbar_booking_list')(true)(bookingList)
            sessionStorage.setItem('hflw_taskbar_booking_list', JSON.stringify(bookingList))
            updateBookingListTabs(bookingList[hotelUuid]);
        }
    }

    const insertOpenModalEvent = (iframeDoc) => {
        $(iframeDoc).on('click', 'a[href*="/booking/detail/?booking_uuid="]', function (event) {
            // this id check is to prevent the modal from loading in the reservations page.
            if ($(this).parent()[0].id !== "navbar_booking_reserva" && $(this).attr('href').match('^/booking/detail/\\?booking_uuid\\=')) {
                event.preventDefault();
                const plainUrl = $(this).attr('href');
                const url = this.protocol + '//' + this.host + this.pathname + this.search + '&template=stripped' + this.hash;
                pathTaken.push(url);
                openbooking(url, plainUrl);
                return false;
            }
        });
    }
    //moved to a snippet inside template=stripped
    const replaceAnchorHREF = (iframeWin) => {
        if (iframeWin.$)
            iframeWin.$('a').each(function () {
                const $this = $(this);
                if ($this.attr('href')) {
                    const splitAtNext = (this.search.indexOf('?') >= 0 ? this.search.replace(/&template=stripped/g, '').split('&next=') : '?');
                    const search = `${splitAtNext[0]}${splitAtNext[1] ? `&template=stripped&next=${splitAtNext[1]}&template=stripped` : '&template=stripped'}`;
                    const url = this.protocol + '//' + this.host + this.pathname + search + this.hash;
                    $this.attr('href', url);
                    $this.click(function () { window.top.pageSupposedToLoad = $(this).attr('href') })
                }
            });
    }
    const insertOnSubmitUpdateCalendarFlag = (iframeWin) => {
        if (iframeWin.$)
            iframeWin.$('form').submit(() => { shouldUpdateCalendar = true })
    }
    const insertToIframe = (iframeWin, iframeDoc) => {
        iframeWin.onbeforeunload = null;
        insertOpenModalEvent(iframeDoc);
        //replaceAnchorHREF(iframeWin);
        insertOnSubmitUpdateCalendarFlag(iframeWin);
    }
    const onloadInsertToIframe = () => {
        bookingPreviewIframe.on('load', () => {
            const iframeWin = bookingPreviewIframe[0].contentWindow;
            const iframeDoc = bookingPreviewIframe[0].contentDocument;
            if (!iframeDoc) { XFrameError(); return; };
            insertToIframe(iframeWin, iframeDoc);
            openPageUrl = iframeWin.location.href;
            pathTaken.push(openPageUrl);
        })
    }

    const XFrameError = () => {
        const errText = `BookingModal X-Frame-Options: DENY`;
        if (window.Sentry) Sentry.captureMessage(errText, {
            level: 'warning',
            extra: { 'broken-url': window.top.pageSupposedToLoad, 'coming-from': pathTaken.map((ele, i) => `${i + 1}: ${ele}`).join("\r\n") }
        })
        location.replace(window.top.pageSupposedToLoad.replace(/&template=stripped/g, ''));
    }

    const createBookingPreviewBtn = (bookingUuid, bookingUrl, bookingNumber) => {
        const previewBtn = $(`<a class="btn btn-primary btn-outline btn-sm ${bookingUuid} bookingPreviewBtn" href="${bookingUrl}"><span class="bookingPreviewBtnText">${bookingNumber}</span></a>`);
        const closeBtn = $('<span class="btn btn-outline previewCloseBtn"><i class="fa fa-close fa-fw"></i></span>')
        closeBtn.click((e) => {
            e.preventDefault();
            e.stopPropagation();
            if (openBookingUuid === bookingUuid) bookingPreviewModal.modal("hide");
            removeBookingPreviewBtn(bookingUuid);
        })
        previewBtn.append(closeBtn);
        if (openBookingUuid === bookingUuid) setActive(previewBtn);
        holder.append(previewBtn)
    }

    const removeBookingPreviewBtn = (bookingUuid) => {
        bookingUuid = bookingUuid ? bookingUuid : openBookingUuid;
        bookingListRemove(bookingUuid);
    }

    const setupModalCloseEvent = () => {
        bookingPreviewModal.on('hide.bs.modal', () => {
            $('.ibox-content').removeClass('no-print')
            openBookingUuid = "";
            if (shouldUpdateCalendar && window.TimeScheduler) {
                try {
                    window.TimeScheduler.Init()
                } catch (e) { };
            }
            shouldUpdateCalendar = false;
            pathTaken = [];
            toggleActive();
        });
    }

    const openModal = (url, loadingTemplate="booking") => new Promise((resolve, reject) => {
        if (window.makeDoubleSwap) {
            url = window.makeDoubleSwap;
            window.makeDoubleSwap = '';
        }
        // if () {
        //     window.makeDoubleSwap = '';
        // }
        $('.ibox-content').addClass('no-print')
        bookingPreviewModal.modal();
        window.top.pageSupposedToLoad = url;
        pathTaken = [];
        makeLoadingSkeleton(loadingTemplate);
        if(templateOptions[loadingTemplate].showPopButton) {
            popModalButton.show();
        } else {
            popModalButton.hide();
        }
        if(templateOptions[loadingTemplate].showMinimizeButton) {
            minimizeModalButton.show();
        } else {
            minimizeModalButton.hide();
        }
        loadingWrapper.show();
        bookingPreviewIframe.hide();
        const handler = function () {
            loadingWrapper.hide();
            bookingPreviewIframe.show();
            bookingPreviewIframe.off('load', handler);
            const iframeDoc = bookingPreviewIframe[0].contentDocument;
            if (!iframeDoc) { XFrameError(); reject(); }
            resolve(iframeDoc);
        }
        bookingPreviewIframe.on('load', handler);
        bookingPreviewIframe.attr('src', url);
    });

    window.openModal = openModal;

    const openbooking = (url, plainUrl) => {
        const bookingList = getBookingList();
        const bookingUuid = getBookingUuuid(url);
        openBookingUuid = bookingUuid;
        toggleActive();
        openModal(url).then((iframeDoc) => {
            if (!bookingList[bookingUuid]) {
                const bookingNumber = getBookingNumber(iframeDoc.title)
                if (bookingNumber)
                    bookingListAdd(bookingUuid, bookingNumber, plainUrl);
            }
        })
    }

    window.openbooking = openbooking;

    popModalButton.click(() => {
        const currentURL = bookingPreviewIframe[0].contentWindow.location.href;
        const openInTab = getCookie("new-window-tab") === "tab";
        const url = openInTab ? currentURL.replace(/&template=stripped/g, '') : currentURL;

        window.open(url, openInTab ? '_blank' : '', !openInTab ? 'width=1300,height=650,scrollbars=yes,screenX=50,screenY=50' : '');
        removeBookingPreviewBtn();
    })

    closeModalButton.click(() => {
        removeBookingPreviewBtn();
    });

    const updateBookingListTabs = (bookingList) => {
        holder.empty();

        const bookingListArray = [];
        for (let i in bookingList) if (bookingList.hasOwnProperty(i)) bookingListArray.push([i, bookingList[i]]);

        if (bookingListArray.length) {
            bookingListArray.forEach(([bookingUuid, { bookingNumber, url }]) =>
                createBookingPreviewBtn(bookingUuid, url, bookingNumber)
            );
            holder.show();
        } else {
            holder.hide();
        }
    };

    const setActive = (button) => {
        button.removeClass('btn-primary');
        button.addClass('btn-default');
    }
    const unsetActive = (button) => {
        button.removeClass('btn-default');
        button.addClass('btn-primary');
    }
    const toggleActive = () => {
        unsetActive(holder.find('.btn-default'));
        const a = $(holder[0].getElementsByClassName(openBookingUuid)[0])
        setActive(a);
    }

    let timer;

    const bookingListHasUpdate = () => {
        const sessionStorageData = sessionStorage.getItem('hflw_taskbar_booking_list');
        const localStorageData = localStorage.getItem('hflw_taskbar_booking_list');
        if (localStorageData !== sessionStorageData) {
            const hotelUuid = getActiveHotelUuid();
            const bookingList = getBookingList();
            const hotelBookingList = bookingList[hotelUuid] ? bookingList[hotelUuid] : {};
            updateBookingListTabs(hotelBookingList);
            sessionStorage.setItem('hflw_taskbar_booking_list', localStorageData)
            return true;
        }
        return false;
    }

    window.addEventListener('blur', () => {
        timer = setInterval(() => {
            bookingListHasUpdate();
        }, 10000)
    });
    window.addEventListener('focus', () => {
        bookingListHasUpdate();
        clearInterval(timer);
    })
    onloadInsertToIframe();
    setupModalCloseEvent();
    insertOpenModalEvent(document);
    const hotelUuid = getActiveHotelUuid();
    if (hotelUuid) {
        const bookingList = getBookingList()[hotelUuid];
        if (bookingList) updateBookingListTabs(bookingList);
    }

    const sortables = $('.sortable')

    //method to move array form position a to position b
    const shiftArrayItems = function (arr, from, to) {
        arr.splice(to, 0, arr.splice(from, 1)[0]);
        return arr;
    }

    //used to keep track of the starter position
    let indexHelper;
    $('.sortable').sortable({
        tolerance: 'pointer',
        start: function (event, ui) {
            //getting the starter postion
            indexHelper = ui.item.index();
        },
        stop: function (event, ui) {
            //getting the final position
            const dropPosition = ui.item.index();
            let data = JSON.parse(sessionStorage.getItem('hflw_taskbar_booking_list'))
            let sessionStorageItems = data[Object.keys(data)]
            let keys = Object.keys(sessionStorageItems);
            let values = Object.values(sessionStorageItems)

            //shift keys
            keys = shiftArrayItems(keys, indexHelper, dropPosition)
            values = shiftArrayItems(values, indexHelper, dropPosition)

            //crete new object with shifted values
            const shiftedObject = {}
            for (let key of keys) {
                shiftedObject[key] = values[keys.indexOf(key)]
            }
            data[Object.keys(data)] = shiftedObject;

            //updating to the local and sessionStorage
            sessionStorage.setItem('hflw_taskbar_booking_list', JSON.stringify(data))
            localStorage.setItem('hflw_taskbar_booking_list', JSON.stringify(data))

        }
    })
})